import React from 'react';
import ExecutiveTrainingDetail from './ExecutiveTrainingDetail';
import executiveTrainingData from '../data/executiveTrainingData';

const ExecutiveTraining = () => {
  return (
    <main className="page executive-training-page">
      {/* Hero / Intro */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">Executive Training</h1>
          <p className="page-subtitle">
            High-impact programs for leaders driving change—covering strategy, governance,
            analytics, engineering leadership, infrastructure, and more.
          </p>
        </div>
      </section>

      {/* List / Accordion */}
      <section className="page-body">
        <div className="container">
          <ExecutiveTrainingDetail executiveTrainingData={executiveTrainingData} />
        </div>
      </section>
    </main>
  );
};

export default ExecutiveTraining;
